import React from "react";
import { RangeContext } from "./types";

/**
 * Context wrapper for range datepickers to get rid of ugly properties passing.
 */
export const DatepickerRangeContext = React.createContext<RangeContext>({});